export default __webpack_public_path__ + "static/media/YELP.72abb83e.png";